import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import classNames from 'classnames';
import svgStyles from './SVGStyles.module.css';


export default function SomeFacebookSquareLogoSvgInverted({ className }: StandardSvgProps) {
    return (<svg
        className={classNames(svgStyles.SDefaultSvg, className)}
        viewBox="0 0 60.733 60.733"
        xmlns="http://www.w3.org/2000/svg">
        <foreignObject
            x="0"
            y="0"
            width="60.734"
            height="60.4">
            <div className="gradient" />
        </foreignObject>
        <path
            id="path2"
            d="M 0 0 L 0 3.3535156 C -2.9605918e-16 1.5005175 1.5015643 0.001953125 3.3515625 0.001953125 L 57.378906 0.001953125 C 59.230904 0.001953125 60.731422 1.5005644 60.732422 3.3515625 L 60.732422 57.378906 C 60.732422 59.226904 59.228951 60.730469 57.376953 60.730469 L 41.902344 60.730469 L 41.902344 37.210938 L 49.794922 37.210938 L 50.980469 28.044922 L 41.902344 28.044922 L 41.902344 22.193359 C 41.902344 19.540362 42.63641 17.730469 46.441406 17.730469 L 51.296875 17.728516 L 51.296875 9.53125 C 50.457876 9.4222501 47.579606 9.171875 44.224609 9.171875 C 37.226616 9.171875 32.4375 13.444117 32.4375 21.287109 L 32.4375 28.046875 L 24.523438 28.046875 L 24.523438 37.214844 L 32.4375 37.214844 L 32.4375 60.732422 L 60.734375 60.732422 L 60.734375 0 L 0 0 z M 0 57.378906 L 0 60.732422 L 3.3515625 60.732422 C 1.5015644 60.732422 0 59.231904 0 57.378906 z " />
    </svg>

    );
}
